import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardOut16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconClipboardOut16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.085 2A1.5 1.5 0 0 1 5.5 1h4a1.5 1.5 0 0 1 1.415 1H11a2 2 0 0 1 2 2v3h-1V4a1 1 0 0 0-1-1h-.085A1.5 1.5 0 0 1 9.5 4h-4a1.5 1.5 0 0 1-1.415-1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h3v1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM5 2.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5m2.146 4.646a.5.5 0 0 1 .708 0L13 12.294V9.5a.5.5 0 0 1 1 0V14H9.5a.5.5 0 0 1 0-1h2.793L7.146 7.854a.5.5 0 0 1 0-.708"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardOut16);
